import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SortDirection } from "@air/api/types";
import { tailwindMerge } from "@air/tailwind-variants";
import React, { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SortButton } from "~/components/SortButton/SortButton";
import { TableCell } from "~/components/TableView/TableCell";
import { setSortingFieldAction } from "~/store/configViews/actions";
import { sortingConfigViewOptionsSelector } from "~/store/configViews/selectors";
import { getDefaultSortDirection } from "~/store/configViews/utils";
export const SortableHeader = /*#__PURE__*/ memo((param)=>{
    let { title, sortingType, className, resizeHandle, ...props } = param;
    const dispatch = useDispatch();
    const sortingConfigViewOptions = useSelector(sortingConfigViewOptionsSelector);
    const sortingConfigViewOption = sortingConfigViewOptions.find((opt)=>opt.fieldName === sortingType);
    var _sortingConfigViewOption_sortDirection;
    const sortingConfigDirection = (_sortingConfigViewOption_sortDirection = sortingConfigViewOption === null || sortingConfigViewOption === void 0 ? void 0 : sortingConfigViewOption.sortDirection) !== null && _sortingConfigViewOption_sortDirection !== void 0 ? _sortingConfigViewOption_sortDirection : getDefaultSortDirection(sortingType);
    const onSortToggle = useCallback(()=>{
        // User clicked on a header that is not currently used for sorting
        // - set the sorting field
        // - set the default sorting direction, if available
        if ((sortingConfigViewOption === null || sortingConfigViewOption === void 0 ? void 0 : sortingConfigViewOption.isCurrentSortedOption) === false) {
            dispatch(setSortingFieldAction({
                sortingFieldName: sortingType,
                direction: sortingConfigDirection
            }));
        } else {
            // User clicked on a header that is currently used for sorting
            // - toggle the sorting direction
            if (sortingConfigDirection === SortDirection.desc) {
                dispatch(setSortingFieldAction({
                    sortingFieldName: sortingType,
                    direction: SortDirection.asc
                }));
            } else {
                dispatch(setSortingFieldAction({
                    sortingFieldName: sortingType,
                    direction: SortDirection.desc
                }));
            }
        }
    }, [
        dispatch,
        sortingConfigDirection,
        sortingType,
        sortingConfigViewOption
    ]);
    if (!sortingConfigViewOption) return null;
    return /*#__PURE__*/ _jsxs(TableCell, {
        className: tailwindMerge("p-1.5 px-2", className, !!resizeHandle && "relative"),
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SortButton, {
                isActive: sortingConfigViewOption.isCurrentSortedOption,
                direction: sortingConfigDirection,
                onClick: onSortToggle,
                type: title,
                children: title
            }),
            resizeHandle
        ]
    });
});
SortableHeader.displayName = "SortableHeader";
